import type { ApiClient } from '../../../shared/api/api-client';

export type PaymentStatsProviderDto = {
  provider: string;
  revenue: number;
  count: number;
};

export type PaymentStatsOrgDto = {
  org_id: number;
  org_name: string;
  revenue: number;
  count: number;
};

export type PaymentStatsWeeklyDto = {
  label: string;
  revenue: number;
};

export type PaymentStatsRefTypeDto = {
  reference_type: string;
  revenue: number;
  count: number;
};

export type PaymentStatsDto = {
  total_revenue: number;
  total_count: number;
  from: string;
  to: string;
  month_current_total: number;
  month_delta_pct: number | null;
  by_provider: PaymentStatsProviderDto[];
  per_org: PaymentStatsOrgDto[];
  by_reference_type: PaymentStatsRefTypeDto[];
  weekly_series: PaymentStatsWeeklyDto[];
};

export async function fetchSuperadminPaymentsStats(
  apiClient: ApiClient,
  from?: string,
  to?: string
): Promise<PaymentStatsDto> {
  const params: Record<string, string> = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const qs =
    Object.keys(params).length > 0 ? '?' + new URLSearchParams(params).toString() : '';
  const res = await apiClient.request<unknown>(
    `/superadmin/payments/stats${qs}`,
    { method: 'GET' }
  );
  return res as PaymentStatsDto;
}
